export default {
  // Static API
  terms: "help",
};
